import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  ahsLinks = [
    {
      'title': 'Opleidingsprogramma',
      'url': 'http://www.arteveldehogeschool.be/opleidingen/bachelor/grafische-en-digitale-media/programma'
    },
    {
      'title': 'Iets voor jou?',
      'url': 'http://www.arteveldehogeschool.be/opleidingen/bachelor/grafische-en-digitale-media/iets-voor-jou'
    },
    {
      'title': 'Onze aanpak',
      'url': 'http://www.arteveldehogeschool.be/opleidingen/bachelor/grafische-en-digitale-media/onze-aanpak'
    },
    {
      'title': 'Praktijk',
      'url': 'http://www.arteveldehogeschool.be/opleidingen/bachelor/grafische-en-digitale-media/praktijk-stage-en-bachelorproef'
    },
    {
      'title': 'Trajecten op maat',
      'url': 'http://www.arteveldehogeschool.be/opleidingen/bachelor/grafische-en-digitale-media/trajecten-op-maat-1'
    },
    {
      'title': 'Brochure',
      'url': 'https://www.arteveldehogeschool.be/sites/default/files/bachelor_grafische_en_digitale_media_2018-2019.pdf'
    },
    {
      'title': 'Campus',
      'url': 'http://www.arteveldehogeschool.be/bij-ons-studeren/onze-locaties/campus-mariakerke'
    }
  ];

  gdmLinks = [
    {
      'title': 'Home',
      'url': 'http://www.arteveldehogeschool.be/opleidingen/bachelor/grafische-en-digitale-media/programma'
    },
    {
      'title': 'In de kijker',
      'url': 'http://www.arteveldehogeschool.be/opleidingen/bachelor/grafische-en-digitale-media/iets-voor-jou'
    },
    {
      'title': 'Getuigenissen',
      'url': 'http://www.arteveldehogeschool.be/opleidingen/bachelor/grafische-en-digitale-media/onze-aanpak'
    },
    {
      'title': 'Stage',
      'url': 'http://www.arteveldehogeschool.be/opleidingen/bachelor/grafische-en-digitale-media/praktijk-stage-en-bachelorproef'
    },
    {
      'title': 'Internationaal',
      'url': 'http://www.arteveldehogeschool.be/opleidingen/bachelor/grafische-en-digitale-media/trajecten-op-maat-1'
    },
    {
      'title': 'Showcase',
      'url': 'https://www.arteveldehogeschool.be/sites/default/files/bachelor_grafische_en_digitale_media_2018-2019.pdf'
    },
    {
      'title': 'Contact',
      'url': 'http://www.arteveldehogeschool.be/bij-ons-studeren/onze-locaties/campus-mariakerke'
    }
  ];

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/phildp/ahs/gdm/code/madebygdm/src/app/layout/footer/footer.component.ts